<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">FNOL+</h1>
      </template>
      <template #actions>
        <page-header-action tag="a" href="#" @click.prevent="sendToCreateView">
          New Incident
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <table class="table carpenter">
            <thead>
              <tr>
                <th colspan="3" class="text-center">
                  Please click the "Add Incident" button to add a new incident
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    sendToCreateView() {
      this.$router.push('/first-notice-of-loss-plus/create');
    }
  }
};
</script>
